
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
  Junior Consultant - Training
</h2>

<p class="para_main_notify">
  Junior Consultant (Training) are meant to be engaged at NSTI's for imparting training in theory and practical related to their subject. JC at CSTARI will be engaged in curriculum development activities .
</p>
  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">

            <!-- feature box begin -->
            <div class="col-md-12 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-graduation-cap" aria-hidden="true"></i>
                <div class="text para_cls">
                  <h3>	Qualifications and experience:</h3>

                    <p> <span class="step_no">1</span> 1.	B.Tech / B.E (having minimum of 2 years of Experience) / Diploma (having minimum of 5 years of Experience) / CITS with at least 3 years of experience in the requisite field.  </p>
                    <p> <span class="step_no">2</span>	2.	Retired Government employees with Level 7 and above in the Pay Matrix, having experience of at least 5 years in the required domain field would also be eligible for the position.  </p>
                    <p> <b> Note: </b>The candidature of the candidate who is appearing in exam for JCs of training profiles, shall be cancelled if the candidate fails in practical examination i.e., Qualifying practical examination is mandatory for Training profile JCs.  </p>


                </div>
              </div>
            </div>
            <!-- feature box close -->

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-gavel"></i>
            <div class="text para_cls">
              <h3>General Conditions </h3>

              <p> <span class="step_no">1</span>Junior Consultants will be engaged for a period of eleven months from the date of Engagement. </p>
              <p> <span class="step_no">2</span>	The services of JCs may be continued for a period of another 11 Months with a break of 1 Month if found suitable by the competent authority of NSTI/RDSDE/DGT/CSTARI. </p>
              <p> <span class="step_no">3</span>	Retired Government employees with experience in the relevant field would also be eligible for selection as Junior Consultants. </p>
              <p> <span class="step_no">4</span>	Consultants shall be appointed on a full-time basis and would not be permitted to take up any other assignment during the period of Consultancy. </p>
              <p> <span class="step_no">5</span>	The engagement is purely on temporary nature and the appointment can be cancelled at any time without providing any reason for it. </p>
              <p> <span class="step_no">6</span>	The reservation policy applicable for Central Government services should be strictly followed in the selection process of JCs. </p>
              <p> <span class="step_no">7</span>	An agreement on stamp paper of Rs.100 /- duly notarized, must be signed between the Director of the Institute and incumbent (Junior Consultant). </p>
              <p> <span class="step_no">8</span>	A waitlist of qualified candidates (nearly 2 times the no. of vacancy of JCs) is to be prepared & should kept in panel for three years. They will be considered against transfer, resignation, death etc. cases. </p>










            </div>
          </div>
        </div>
        <!-- feature box close -->




  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-list-alt"></i>
      <div class="text para_cls">
        <h3>Selection Process</h3>
        <p><span class="step_no">1</span>Submission of online application by candidates</p>
        <p><span class="step_no">2</span>Scrutinizing of Applications received and Issue of Admit Card </p>
        <p><span class="step_no">3</span>Conduct of All India CBT Exam for selection of pool of candidates Online </p>
        <p><span class="step_no">4</span>Calling the CBT qualified candidates Regional wise for Practical Exams in order of Merit (based on CBT marks) in 1:6 ratios digitally </p>
        <p><span class="step_no">5</span>Conduction of Practical Exams, Region wise for selected candidates </p>
        <p><span class="step_no">6</span>Calculation of Score Card and Result of the Candidates (3 Times the number of JCs) in order of merit as per the Score card.</p>
        <p><span class="step_no">7</span>Selected candidates Panel list (3 Times the number of JCs) published by DGT  </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->


  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-book"></i>
      <div class="text para_cls">
        <h3>Application Fees</h3>
        <p><span class="step_no">1</span>Rs. 500 to be paid online during the application process.</p>

      </div>
    </div>
  </div>
  <!-- feature box close -->


    <!-- feature box begin -->
    <div class="col-md-12 feature-box mb40 sq-item wow">
      <div class="feature-box style-2 left">
        <i class="fa fa-calculator"></i>
        <div class="text">
          <h3>Score Card Calculations</h3>

          <div class="container">
            <div class="row">

              <div class="col-md-12">
                <table>
                  <thead>
                      <th>S.No</th>
                      <th>Examination/Experience/Qualification </th>
                      <th style="width: 15%; text-align: center;">Maximum Marks</th>
                      <th style="text-align: center;">Split up</th>
                  </thead>

                  <tr>
                    <td>1</td>
                    <td>CBT Examination </td>
                    <td class="num_marks">100</td>
                    <td>Total CBT Marks obtained out of 100 Marks  </td>
                  </tr>

                  <tr>
                    <td>2</td>
                    <td>Practical Examination  </td>
                      <td class="num_marks">100 </td>
                    <td> Total Practical Marks obtained out of 100 Marks
          <!-- 2 Marks per year of Experience after acquiring minimum qualification & experience as prescribed in Para C above.  -->
                       </td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Experience   </td>
                    <td class="num_marks">10 </td>
                    <td>	<p>2 Marks per year of Experience after acquiring minimum qualification & experience as prescribed in Para C above</p>
                      <p> (Maximum limit is 10 Marks for 5 years of experience after acquiring minimum qualification & experience as prescribed in Para C above.)  </p>
                    </td>

                  </tr>
                  <tr>
                    <td>4</td>
                    <td>CITS Qualification Points  </td>
                    <td class="num_marks"> 50            </td>
                    <td>	<p> For CITS with Degree or higher 	50 Marks  </p>
                      <p> For CITS with Diploma 	40 Marks </p>
                    <p>		For CITS 	30 Marks </p>
                    </td>

                  </tr>
                  <tr class="last_tr">
                    <td></td>
                    <td>Total Marks </td>
                    <td class="num_marks">  260 </td>
                    <td></td>
                  </tr>

                </table>
              </div>
            </div>
          </div>


        </div>
      </div>


      <!--Content Start-->






      <!--Content End-->

        <!--Content Start-->






      <!--Content End-->



    </div>
    <!-- feature box close -->


     <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-gavel"></i>
      <div class="text para_cls">
        <h3>Tie Breaker Rules</h3>


        <div class="container">
          <div class="row">

            <div class="col-md-12">
              In case of tie between the Marks of set of candidates, the following criteria will be applicable in Priority basis to settle the tie.
            </div>
            <div class="col-md-12">
              <table>

                <tr>
                  <td>1</td>
                  <td> First Preference  </td>
                  <td> Qualified CITS in relevant trade with Degree or Higher  </td>
                </tr>

                <tr>
                  <td>2</td>
                  <td>Second Preference   </td>
                    <td>2 	Second Preference 	Qualified CITS in relevant trade with Diploma  </td>

                </tr>

                <tr>
                  <td>3</td>
                  <td>Third Preference   </td>
                  <td>3 	Third Preference 	Qualified CITS in relevant trade            </td>


                </tr>
                <tr>
                  <td>4</td>
                  <td>Fourth Preference  </td>
                  <td> Practical Marks  </td>
                </tr>

                <tr>
                  <td>5</td>
                  <td>Fifth Preference   </td>
                  <td> CBT Marks   </td>
                </tr>
                <tr style="border-bottom: 1px solid #999;">
                  <td>6</td>
                  <td>Sixth Preference    </td>
                  <td> Retired Govt. Employee with experience in the relevant field    </td>
                </tr>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- feature box close -->

       <!-- feature box begin -->
       <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-clock-o"></i>
          <div class="text para_cls">
            <h3>Recruitment Process and Time Schedule </h3>


            <div class="container">
              <div class="row">


                <div class="col-md-12">
                  <table>
                    <thead>
                      <td>Sl.no</td>
                      <td style="width: 50%;">Activity/Process</td>
                      <td>Timelines</td>
                      <td>To be done by</td>
                    </thead>
                    <tr>
                      <td>1</td>
                      <td> Publishing of the Applications Centrally Online for engaging Junior Consultants  </td>
                      <td> 09-04-2021  </td>
                      <td> by NIMI  </td>
                    </tr>

                    <tr>
                      <td>2</td>
                      <td>Scrutinizing of Applications received, Issue of Admit Card   </td>
                        <td>13-05-21 to 15-05-21  </td>
                        <td> by NIMI  </td>
                    </tr>

                    <tr>
                      <td>3</td>
                      <td>Informing the CBT qualified candidates Regional wise for Practical Exams in order of Merit (based on CBT marks) in 1:6 ratio digitally   </td>
                      <td>22-05-2021    </td>
                      <td> by NIMI  </td>

                    </tr>
                    <tr>
                      <td>4</td>
                      <td> Conduct of All India CBT Exam for selection of pool of candidates Online </td>
                      <td> 29-05-21 to 31-05-21  </td>
                      <td> by NIMI  </td>
                    </tr>

                    <tr>
                      <td>5</td>
                      <td>Practical Exams to be conducted Region wise for above sorted candidates Issue of call letters to meritorious candidates   </td>
                      <td> 14-06-21 to 16-06-21   </td>
                      <td> by NSTIs  </td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td> Issue of call letters to meritorious candidates   </td>
                      <td>    </td>
                      <td> by NSTIs  </td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Calculation of Score Card/Result of the Candidates (3 Times the number of JCs) in order of merit as per the Score card rule mentioned in JC guidelines    </td>
                      <td>  25-06-2021    </td>
                      <td> by NIMI  </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #999;">
                      <td>8</td>
                      <td>Selected candidates Panel list (3 Times the number of JCs) with scorecard to be sent from NIMI to DGT HQRS for approval   </td>
                      <td>  30-06-2021    </td>
                      <td> by NIMI  </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Entitlements of Consultants</h3>

        <p><span class="step_no">1</span>The full-time candidates will be paid a monthly consolidated remuneration of Rs. 45,000/ </p>
        <p><span class="step_no">2</span>In the case of retired Govt. servants, the remuneration shall be as per prevailing DoPT norms.  </p>
        <p><span class="step_no">3</span>The Consultants will not be eligible for Government Accommodation or House Rent Allowance, CGHS facility, Official email i.d., Government identification card, internet connection, telephone, etc.  </p>
        <p><span class="step_no">4</span> <b> TA/DA:  </b>  If the Tour program is in interest of Public Service, then they are entitled to allowances as applicable in the Level-6</p>
        <p><span class="step_no">5</span> <b> Leave:  </b>  The JCs shall be entitled to leave of 8 days in a year on pro rata basis. Additional leave without pay would be permitted upon approval by the Concerned Competent Authority. </p>
        <p> <span class="step_no">6</span> <b> Conflict of interest:  </b> He/she will be expected to display utmost honesty, secrecy of office and sincerely while discharging his/her duties. In case, the services of the Consultant are not found satisfactory or found in conflict with the interests of the Government, his/her services will be liable for discontinuation without assigning any reason.
          </p>
          <p> <span class="step_no">7</span> <b> Termination Notice:  </b> The Competent Authority can cancel the appointment at any time without providing any reason for it. However, in the normal course it will provide one month’s notice to the Consultant.
          </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

      </div>
    </div>

    <!-- <div class="col-md-4">
      <figure class="picframe invert transparent hover-shadow rounded">
                            <span class="overlay-v">
            <span class="v-center">
              <span>
                <a id="play-video" class="video-play-button popup-youtube" href="https://www.youtube.com/watch?v=CmCIZ_aUAeQ">
                  <span></span>
                </a>
              </span>
            </span>
          </span>
                        <img src="assets/images/misc/2.jpg" class="img-fullwidth" alt="">
                    </figure>
    </div> -->
  </div>

        </div>
    </section>
    <!-- section close -->

<!-- section begin -->
    <section class="bg-color text-light pt60 pb60">
        <div class="container">

            <div class="row">
                <div class="col-md-2 col-sm-6 col-xs-6 mb-sm-30">
                    <div class="de_count">
                        <h3 class="timer" data-to="25" data-speed="2500">25</h3>
                        <span>Institutes </span>
                    </div>
                </div>

                <div class="col-md-2 col-sm-6 col-xs-6 mb-sm-30">
                    <div class="de_count">
                        <h3 class="timer" data-to="80">80</h3>
                        <span>VACANCIES</span>
                    </div>
                </div>



                <div class="col-md-2 col-sm-6 col-xs-6 mb-sm-30">
                    <div class="de_count">
                        <h3 class="timer" data-to="49" data-speed="2500">49</h3>
                        <span>NSTI-G</span>
                    </div>
                </div>

                <div class="col-md-2 col-sm-6 col-xs-6 mb-sm-30">
                  <div class="de_count">
                      <h3 class="timer" data-to="20" data-speed="2500">20</h3>
                      <span>NSTI-W</span>
                  </div>
              </div>
              <div class="col-md-2 col-sm-6 col-xs-6 mb-sm-30">
                <div class="de_count">
                    <h3 class="timer" data-to="11" data-speed="2500">11</h3>
                    <span>CSTARI</span>
                </div>
            </div>
            <div class="col-md-2 col-sm-6 col-xs-6 mb-sm-30">
              <div class="de_count">
                  <h3 class="timer" data-to="45000">45000</h3>
                  <span>remuneration</span>
              </div>
          </div>
            </div>
        </div>
    </section>
    <!-- section close -->


    <div class="row notifi_main_table ">
      <div class="col-md-12">
    <h2>
      JCs requirement based on Trade
    </h2>

          <!--Content Start-->




          <div class="container">
            <div class="row">

              <div class="col-md-12">
                <table>
                  <thead>
                      <th>S.No</th>
                      <th>CITS Trades  </th>
                      <th style="text-align: center;">NSTI-G </th>
                      <th style="text-align: center;">NSTI-W </th>
                      <th style="text-align: center;">CSTARI </th>
                  </thead>
                  <tr><td>1</td><td>Architectural Draughtsman </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>2</td><td>Catering & Hospitality </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>3</td><td>Carpenter </td><td>0</td><td>0</td><td>1</td></tr>
                  <tr><td>4</td><td>Computer Hardware & Maintenance </td><td>2</td><td>0</td><td>1</td></tr>
                  <tr><td>5</td><td>Computer Software Application </td><td>6</td><td>1</td><td>1</td></tr>
                  <tr><td>6</td><td>Cosmetology </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>7</td><td>Desktop Publishing Operator </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>8</td><td>Draughtsman Civil </td><td>1</td><td>1</td><td>1</td></tr>
                  <tr><td>9</td><td>Dress making </td><td>1</td><td>0</td><td>0</td></tr>
                  <tr><td>10</td><td>Fashion Design & Technology </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>11</td><td>Electrician/wireman </td><td>2</td><td>0</td><td>0</td></tr>
                  <tr><td>12</td><td>Electronics Mechanic </td><td>3</td><td>0</td><td>0</td></tr>
                  <tr><td>13</td><td>Fitter </td><td>4</td><td>0</td><td>1</td></tr>
                  <tr><td>14</td><td>Foundryman </td><td>1</td><td>0</td><td>0</td></tr>
                  <tr><td>15</td><td>Instrument Mechanic </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>16</td><td>Mechanics Agriculture Machinery/Farm Machinery </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>17</td><td>Machinist & Operator Adv Machine Tool </td><td>1</td><td>0</td><td>1</td></tr>
                  <tr><td>18</td><td>Machinist Grinder </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>19</td><td>Mechanic Diesel </td><td>1</td><td>0</td><td>1</td></tr>
                  <tr><td>20</td><td>Mechanic Machine Tool Maintenance or Millwright (MMW) </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>21</td><td>Mechanic Refrigeration and Air-conditioning </td><td>1</td><td>0</td><td>1</td></tr>
                  <tr><td>22</td><td>Mechanic Motor Vehicle </td><td>1</td><td>0</td><td>1</td></tr>
                  <tr><td>23</td><td>Office Management </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>24</td><td>Plumber </td><td>1</td><td>0</td><td>0</td></tr>
                  <tr><td>25</td><td>Secretarial Practice (Hindi) </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>26</td><td>Sewing Technology </td><td>2</td><td>0</td><td>1</td></tr>
                  <tr><td>27</td><td>Sheet Metal Worker </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>28</td><td>Tool and Die Maker </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>29</td><td>Surface Ornamentation Technique </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>30</td><td>Mechanic Tractor </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>31</td><td>Turner </td><td>0</td><td>0</td><td>0</td></tr>
                  <tr><td>32</td><td>Welder </td><td>5</td><td>0</td><td>1</td></tr>
                  <tr><td>33</td><td>Draughtsman Mechanical /RODA/ED </td><td>1</td><td>0</td><td>0</td></tr>
                  <tr><td>34</td><td>Workshop Calculation & Science </td><td>3</td><td>8</td><td>0</td></tr>
                  <tr><td>35</td><td>POT </td><td>13</td><td>1</td><td>0</td></tr>
                  <tr><td>36</td><td>Soft Skilll</td><td>0</td><td>9</td><td>0</td></tr>
                  <tr class="last_tr"><td> </td><td>Total</td><td>49</td><td>20</td><td>11</td></tr>





                </table>
              </div>
            </div>
          </div>

        <!--Content End-->

        <h2>
          JCs requirement based on Institutes
        </h2>

        <div class="container">
          <div class="row">

            <div class="col-md-12">
              <table>
                <thead>
                    <th>S.No</th>
                    <th>Name of the Institutes  </th>
                    <th >Junior Consultant </th>

                </thead>

                <tr><td>1</td><td>NSTI W Noida</td><td>2</td></tr>
        <tr><td>2</td><td>NSTI W Mumbai</td><td>2</td></tr>
<tr><td>3</td><td>NSTI W Bangalore</td><td>2</td></tr>
<tr><td>4</td><td>NSTI W Trivandrum</td><td>0</td></tr>
<tr><td>5</td><td>NSTI W Panipat</td><td>0</td></tr>
<tr><td>6</td><td>NSTI W Kolkata</td><td>2</td></tr>
<tr><td>7</td><td>NSTI W Tura</td><td>1</td></tr>
<tr><td>8</td><td>NSTI W Indore</td><td>1</td></tr>
<tr><td>9</td><td>NSTI W Vadodara</td><td>1</td></tr>
<tr><td>10</td><td>NSTI W Allahabad</td><td>3</td></tr>
<tr><td>11</td><td>NSTI W Jaipur</td><td>2</td></tr>
<tr><td>12</td><td>NSTI W Shimla</td><td>2</td></tr>
<tr><td>13</td><td>NSTI W Mohali</td><td>0</td></tr>
<tr><td>14</td><td>NSTI W Patna</td><td>0</td></tr>
<tr><td>15</td><td>NSTI W Trichy</td><td>0</td></tr>
<tr><td>16</td><td>NSTI W Jammu</td><td>2</td></tr>
<tr><td>17</td><td>NSTI W Goa</td><td>0</td></tr>
<tr><td>18</td><td>NSTI W Hyderabad</td><td>0</td></tr>
<tr><td>19</td><td>NSTI W Agartala</td><td>0</td></tr>
<tr><td>20</td><td>NSTI Chennai</td><td>7</td></tr>
<tr><td>21</td><td>NSTI Calicut</td><td>3</td></tr>
<tr><td>22</td><td>NSTI Bhubaneswar</td><td>0</td></tr>
<tr><td>23</td><td>NSTI Hyderabad (V)</td><td>2</td></tr>
<tr><td>24</td><td>NSTI Jodhpur</td><td>2</td></tr>
<tr><td>25</td><td>NSTI Ludhiana</td><td>2</td></tr>
<tr><td>26</td><td>NSTI Haldwani</td><td>2</td></tr>
<tr><td>27</td><td>NSTI Mumbai</td><td>7</td></tr>
<tr><td>28</td><td>NSTI Dehradun</td><td>4</td></tr>
<tr><td>29</td><td>NSTI Hyderabad R</td><td>3</td></tr>
<tr><td>30</td><td>NSTI Kolkata, Howrah</td><td>6</td></tr>
<tr><td>31</td><td>NSTI Kanpur</td><td>6</td></tr>
<tr><td>32</td><td>NSTI Jamshedpur</td><td>2</td></tr>
<tr><td>33</td><td>NSTI Bengaluru</td><td>3</td></tr>
<tr><td>34</td><td>CSTARI</td><td>11</td></tr>
<tr class="last_tr"><td> </td><td>TOTAL </td><td>80</td></tr>

</table>
</div>
</div>
        </div>

        <h2>
          JC Training vacancies Trade wise Institutes wise
        </h2>

        <div class="container">
          <div class="row">

            <div class="col-md-12">
              <table style="display: block; overflow: scroll; height: 500px;">
                <thead>
                <th>Sl. no.</th><th>CITS Trades / NSTI(G)</th><th>NSTI W Noida</th><th>NSTI W Mumbai</th><th>NSTI W Bangalore</th><th>NSTI W Kolkata</th><th>NSTI W Tura</th><th>NSTI W Indore</th><th>NSTI W Vadodara</th><th>NSTI W Allahabad</th><th>NSTI W Jaipur</th><th>NSTI W Shimla</th><th>NSTI W Jammu</th><th>NSTI Chennai</th><th>NSTI Calicut</th><th>NSTI Hyderabad (V)</th><th>NSTI Jodhpur</th><th>NSTI Ludhiana</th><th>NSTI Haldwani</th><th>NSTI Mumbai</th><th>NSTI Dehradun</th><th>NSTI Hyderabad R</th><th>NSTI Kolkata, Howrah</th><th>NSTI Kanpur</th><th>NSTI Jamshedpur</th><th>NSTI Bengaluru</th><th>Vacancies in CSTARI</th><th>Vacancies in NSTI(G)</th><th>Vacancies in NSTI(W)</th><th>Trade Vacancies</th>
                </thead>
                <tr><td>1</td><td>Carpenter</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>1</td></tr>
                <tr><td>2</td><td>Computer Hardware & Maintenance</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>2</td><td>0</td><td>3</td></tr>
                <tr><td>3</td><td>Computer Software Application</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>1</td><td>0</td><td>1</td><td>0</td><td>1</td><td>1</td><td>6</td><td>1</td><td>8</td></tr>
                <tr><td>4</td><td>Draughtsman Civil</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>1</td><td>3</td></tr>
                <tr><td>5</td><td>Dress making</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td></tr>
                <tr><td>6</td><td>Electrician/wireman</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>2</td><td>0</td><td>2</td></tr>
                <tr><td>7</td><td>Electronics Mechanic</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td><td>0</td><td>1</td><td>0</td><td>3</td><td>0</td><td>3</td></tr>
                <tr><td>8</td><td>Fitter</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td><td>0</td><td>1</td><td>4</td><td>0</td><td>5</td></tr>
                <tr><td>9</td><td>Foundryman</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td></tr>
                <tr><td>10</td><td>Machinist & Operator Advance Machine Tool</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>2</td></tr>
                <tr><td>11</td><td>Mechanic Diesel</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>2</td></tr>
                <tr><td>12</td><td>Mechanic Refrigeration and Air-conditioning</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>2</td></tr>
                <tr><td>13</td><td>Mechanic Motor Vehicle</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>2</td></tr>
                <tr><td>14</td><td>Plumber</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td></tr>
                <tr><td>15</td><td>Sewing Technology</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>2</td><td>0</td><td>0</td><td>1</td><td>2</td><td>0</td><td>3</td></tr>
                <tr><td>16</td><td>Welder</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td><td>1</td><td>5</td><td>0</td><td>6</td></tr>
                <tr><td>17</td><td>Draughtsman Mechanical /RODA/ED</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td></tr>
                <tr><td>18</td><td>Workshop Calculation & Science</td><td>1</td><td>1</td><td>1</td><td>1</td><td>0</td><td>0</td><td>1</td><td>1</td><td>1</td><td>1</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>3</td><td>8</td><td>11</td></tr>
                <tr><td>19</td><td>POT/Technical Officer</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>1</td><td>2</td><td>2</td><td>0</td><td>1</td><td>0</td><td>2</td><td>2</td><td>0</td><td>3</td><td>0</td><td>0</td><td>0</td><td>0</td><td>13</td><td>1</td><td>14</td></tr>
                <tr><td>20</td><td>Soft Skills</td><td>1</td><td>1</td><td>1</td><td>1</td><td>1</td><td>1</td><td>0</td><td>1</td><td>1</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>9</td><td>9</td></tr>
                <tr class="last_tr"><td></td><td>Total</td><td>2</td><td>2</td><td>2</td><td>2</td><td>1</td><td>1</td><td>1</td><td>3</td><td>2</td><td>2</td><td>2</td><td>7</td><td>3</td><td>2</td><td>2</td><td>2</td><td>2</td><td>7</td><td>4</td><td>3</td><td>6</td><td>6</td><td>2</td><td>3</td><td>11</td><td>49</td><td>20</td><td>80</td></tr>
                </table>
</div>
</div>
        </div>

      </div>
    </div>

    <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center; padding: 30px 0px;">
      <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
  </div>

  <div class="container big_padd">








      </div>



    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>
